import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';

const GuestButton = styled(Button)(({ theme }) => ({
  borderRadius: 2,
  fontSize: '0.75rem',
  // textTransform: 'none',
  color: theme.palette.text.primary,
  '&:disabled': {},
}));

export default GuestButton;

export const GuestButtonLoading = styled(LoadingButton)(({ theme }) => ({
  borderRadius: 2,
  color: theme.palette.text.primary,
  '&:disabled': {},
}));
